import { defineStore } from "pinia";
const globalStore = defineStore("global", {
    state: () => {
        return {
            isNavOpen: true,
            isModalOpen: false,
            selectMenu: 0,
            pageSize: 0,
            nationList: [] as Array<any>,
            dept: [] as Array<any>,
            position: [] as Array<any>,
            type: [] as Array<any>,
            detailType: [] as Array<any>,
            searchDate: [] as any,
            gubun: [] as Array<any>,
            industry: [] as Array<any>,
        };
    },
    actions: {
        setNavOpen(isNavOpen: boolean) {
            this.isNavOpen = isNavOpen;
        },
        setModalOpen(isModalOpen: boolean) {
            this.isModalOpen = isModalOpen;
        },
        setSelectMenu(MenuIdx: number) {
            this.selectMenu = MenuIdx;
        },
        setPageSize(selectSize: number) {
            this.pageSize = selectSize;
        },
        setNationList(list: Array<any>) {
            this.nationList = list;
        },
        setDept(list: Array<any>) {
            this.dept = list;
        },
        setPosition(list: Array<any>) {
            this.position = list;
        },
        setType(list: Array<any>) {
            this.type = list;
        },
        setDetailType(list: Array<any>) {
            this.detailType = list.map((dtlType) => {
                let idx; // 유형Idx: 0 - 분석중, 1 - 분석완료, 2 - 없음
                if (dtlType.idx === 0) {
                    // 세부유형idx: 0 - 미확인
                    idx = 0;
                    // } else if (dtlType.idx === 9) {
                    //     // 세부유형idx: 9 - 해당없음
                    //     idx = 2;
                } else {
                    idx = 1;
                }

                return { idx: dtlType.idx, name: dtlType.name, typeIdx: idx };
            });
        },
        setSearchDate(Date: any) {
            this.searchDate = Date;
        },
        setGubun(list: Array<any>) {
            this.gubun = list;
        },
        setIndustry(list: Array<any>) {
            this.industry = list;
        },
    },
});

export default globalStore;
